import classNames from 'classnames'
import React, { ComponentPropsWithRef, ReactNode } from 'react'
import { LinkProps } from 'react-router'

export const RowActionWrapper = ({
  children,
  selected,
  className,
  as,
  ...props
}: {
  children: ReactNode
  selected?: boolean
  className?: string
} & {
  to: string
  as: React.ElementType<React.RefAttributes<HTMLAnchorElement> & LinkProps>
} & ComponentPropsWithRef<'a'>) => {
  const LinkComponent = as
  return (
    <LinkComponent
      {...props}
      className={classNames(
        'h-8 w-8 bg-white rounded-xs hover-aa-supported flex items-center justify-center',
        selected && 'selected-aa-supported',
        className
      )}
    >
      {children}
    </LinkComponent>
  )
}
